import { ReactElement } from 'react';
import { colors } from '~/styles/colors';

type IndicatorPolygonIconProps = {
  color?: string;
  size?: string;
  rotate?: string
}

export const IndicatorPolygonIcon = ({
  size = '8',
  color = colors.icon['white-0'],
  rotate,
}: IndicatorPolygonIconProps): ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 6 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      rotate,
    }}
  >
    <path d="M1.86737 4.5C2.25227 5.16667 3.21452 5.16667 3.59942 4.5L5.33148 1.5C5.71638 0.833333 5.23525 0 4.46545 0H1.00135C0.231547 0 -0.249578 0.833333 0.135322 1.5L1.86737 4.5Z" fill={color} />
  </svg>
);
